import { constants } from 'helpers'
import { useFt } from 'hooks'


const useFeaturedBrand = (): BrandsModule.FeaturedBrand => {
  const isDeckOfScarletPageEnabled = useFt(constants.features.websiteTakeoverDOS)
  const isTheHarmonistPageEnabled = useFt(constants.features.websiteTakeoverHarmonist)

  if (isDeckOfScarletPageEnabled) {
    return 'deck-of-scarlet'
  }

  if (isTheHarmonistPageEnabled) {
    return 'the-harmonist'
  }

  return null
}

export default useFeaturedBrand
